module.exports = __webpack_public_path__ + "./fonts/DMSans-BoldItalic.f303dd.woff";